module.exports = "/assets/d8bc51dc29fb5a47e2e07e3da935a8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OO.png
// module id = 1687
// module chunks = 0